import React, { useMemo } from "react";
import useRouteUtils from "../../utils/hooks/useRouteUtils";
import { useSelector } from "react-redux";

const useReport = () => {
  const { checkIfActiveRoute } = useRouteUtils();
  const globalState = useSelector((state) => state.global);
  const drawerMenu = [
    {
      title: "Best Seller",
      link: "/report/best-seller",
      icon: <span className="material-symbols-outlined x4">star</span>,
      active: checkIfActiveRoute("/report/best-seller", true),
    },
    {
      title: "Most Spent Customer",
      link: "/report/most-spent-customer",
      icon: <span className="material-symbols-outlined x4">groups_3</span>,
      active: checkIfActiveRoute("/report/most-spent-customer", true),
    },
    {
      title: "Earning And Redemption",
      link: "/report/earning-redemption",
      icon: <span className="material-symbols-outlined x4">savings</span>,
      active: checkIfActiveRoute("/report/earning-redemption", true),
    },
    {
      title: "Repeat Order",
      link: "/report/repeat-order",
      icon: <span className="material-symbols-outlined x4">orders</span>,
      active: checkIfActiveRoute("/report/repeat-order", true),
    },
    {
      title: "Repeat Customer",
      link: "/report/repeat-customer",
      icon: <span className="material-symbols-outlined x4">person</span>,
      active: checkIfActiveRoute("/report/repeat-customer", true),
    },
    {
      title: "Gift Card Purchase",
      link: "/report/gift-cards-purchase",
      icon: <span className="material-symbols-outlined x4">redeem</span>,
      active: checkIfActiveRoute("/report/gift-cards-purchase", true),
    },
    {
      title: "Wallet Transaction",
      link: "/report/wallet-transaction",
      icon: <span className="material-symbols-outlined x4">receipt_long</span>,
      active: checkIfActiveRoute("/report/wallet-transaction", true),
    },
    {
      title: "User Feedback",
      link: "/report/feedback",
      icon: <span className="material-symbols-outlined x4">rate_review</span>,
      active: checkIfActiveRoute("/report/feedback", true),
    },
    {
      title: "Bank Offer(Orders)",
      link: "/report/card-offer",
      icon: <span className="material-symbols-outlined x4">redeem</span>,
      active: checkIfActiveRoute("/report/card-offer", true),
    },
    {
      title: "Qubriux Offer(Orders)",
      link: "/report/qubriux-offer",
      icon: <span className="material-symbols-outlined x4">featured_seasonal_and_gifts</span>,
      active: checkIfActiveRoute("/report/qubriux-offer", true),
    },
    {
      title: "Spin Wheel Rewards",
      link: "/report/spin-wheel-rewards",
      icon: <span className="material-symbols-outlined x4">local_play</span>,
      active: checkIfActiveRoute("/report/spin-wheel-rewards", true),
    },
    /*
      The title has to read exactly as the seeded sub_menu_name ('Subscription Report'):
      the filter below matches the menu on that string, so a mismatch drops the entry
      silently rather than failing.
    */
    {
      title: "Subscription Report",
      link: "/report/subscription",
      icon: <span className="material-symbols-outlined x4">local_cafe</span>,
      active: checkIfActiveRoute("/report/subscription", true),
    },
    /* Brackets included, for the same reason: the seeded name reads exactly this way. */
    {
      title: "Subscription (Orders)",
      link: "/report/subscription-orders",
      icon: <span className="material-symbols-outlined x4">receipt</span>,
      active: checkIfActiveRoute("/report/subscription-orders", true),
    },
  ];

  const drawerMenuPermission = useMemo(() => {
    let menus = Object.values(
      globalState.dashboard_permissions?.menu_permissions ?? []
    )?.flatMap?.((menu) =>
      menu?.sub_menu_permissions?.map((side_menu) => side_menu?.sub_menu_name)
    );
    return drawerMenu
      ?.filter((menu) => {
        return menus?.includes?.(menu?.title);
      })
      ?.map((menu) => {
        return {
          ...menu,
        };
      });
    //eslint-disable-next-line
  }, [globalState.dashboard_permissions, location.pathname]);

  return { drawerMenu: drawerMenuPermission };

};

export default useReport;
